export let state = {
    token: '',
    accessToken: '',
    dataToCapture: [],
    deviceTypes: [],
    deviceIntegrations: [],
    vehicleTypes: [],
    fuelTypes: [],
    eventTypes: [],
    eventAlertLevelType: [],
    roles: [],
    vehicleStatuesType: [],
    snapshotTypes: [],
    singnalR: null,
    connectionId: null,
    logoutTimeout: null,
    snapshotId: null,
    eventId: null,
    centerCarId: null,
    isOverlayActive: false,
    userName: null,
    isMenuActive: false,
    mapFilters: [],
    mapActiveFleets: [],
    requestStatus: null,
    requestType: null,
    isEventPanelActive: false,
    isMediaPanelActive: false,
    mapSettings: {
        map: null,
        ui: null,
        platform: null
    }
}
